export default __webpack_public_path__ + "static/media/edit.4f6d3007.svg";